import script from "./HomeCohortReports.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeCohortReports.vue?vue&type=script&setup=true&lang=js"

import "./HomeCohortReports.vue?vue&type=style&index=0&id=ae851cf4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae851cf4"]])

export default __exports__